import types from './types'

export default {
  setToken: authData => ({ type: types.SET_TOKEN, payload: authData }),
  setIsAdmin: (isAdmin = true) => ({ type: types.SET_IS_ADMIN, payload: isAdmin }),
  acceptTerms: () => ({ type: types.ACCEPT_TERMS }),
  setDefaultChallenge: () => ({ type: types.SET_DEFAULT_CHALLENGE})
}
